import React, { PureComponent } from "react";
import { Button, Table } from "element-react";

import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import Navigation from "../../components/navigation";
import { Message } from "element-react/next";

import icon1 from "../../images/greenli1.png";
// import icon2 from "../../images/greenli2.png";
// import icon3 from "../../images/greenli3.png";
// import icon4 from "../../images/greenli4.png";

import "./index.scss";

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      colspaned: true,
      columns: [
        {
          label: "环节",
          prop: "linkName",
          width: 220
        },
        {
          label: "办理人员",
          prop: "handlingPersonnel",
          width: 150
        },
        {
          label: "办理时限",
          prop: "handlingTime",
          width: 180
        },
        {
          label: "审查标准",
          prop: "reviewCriteria",
        },
        {
          label: "办理结果",
          prop: "handlingResults",
          width: 300
        },
        {
          label: "是否存在特殊环节",
          prop: "specialLinkStatus",
          width: 150,
          render: (text, row, index) => {
            return (
              <span>
                {text.specialLinkStatus == 1 ? '是' : '否'}
              </span>
            )
          },
        }
      ],
      clcolumns: [
        {
          label: "材料名称",
          prop: "materialName",
          width: 150
        },
        {
          label: "材料形式",
          prop: "materialForm",
          width: 120
        },
        {
          label: "来源渠道",
          prop: "sourceChannel",
        },
        {
          label: "纸质材料份数",
          prop: "number",
          width: 120
        },
        {
          label: "填报须知",
          prop: "describe",
          width: 150
        },
        {
          label: "必要性",
          prop: "necessity",
        },
        {
          label: "受理标准",
          prop: "acceptanceConditions",
          width: 150
        },
        {
          label: "样表下载",
          prop: "tableUrlName",
          width: 180,
          render: (text, row, index) => {
            return (
              text.tableUrl ?
                <a href={text.tableUrl} download={text.tableUrlName}>{text.tableUrlName}</a> : <span>暂无下载</span>
            )
          },
        }
      ],
      data: [{
        huanjie: '受理各旗县、盟市上报材料',
        name: '陈xx',
        datatime: 'xx个工作日',
        biaozhun: '申请材料齐全,是否符合法定形式',
        result: '1、申请人的申请符合法定条件、标准的，予以通过；2、申请人的申请不符合法定条件、标准的，不予通过。',
        isexcit: '否',
      }, {
        huanjie: '审查',
        name: '陈xx',
        datatime: 'xx个工作日',
        biaozhun: '申请材料齐全,是否符合法定形式',
        result: '1、申请人的申请符合法定条件、标准的，予以通过；2、申请人的申请不符合法定条件、标准的，不予通过。',
        isexcit: '否',
      }, {
        huanjie: '决定',
        name: '陈xx',
        datatime: 'xx个工作日',
        biaozhun: '申请材料齐全,是否符合法定形式',
        result: '1、申请人的申请符合法定条件、标准的，予以通过；2、申请人的申请不符合法定条件、标准的，不予通过。',
        isexcit: '否',
      }],
      stepdata: [{ id: 1, name: '受理各旗县、盟市上报材料' }, { id: 2, name: '审查' }, { id: 3, name: '决定' }, { id: 4, name: '办结' }],
      detail: {},
      flag:false,
    };
  }


  componentDidMount() {
    const { dispatch, location: { query,state } } = this.props;//路由中参数
    console.log(this.props);
    let urlParam = this.GetUrlParam('id')//url地址栏传参
    let params = {};
    if (query && query.id) {//路由跳转过来的
      params = {
        id: query.id,
      };
    } else if (urlParam) {//url地址栏带参过来的
      params = {
        id: urlParam,
      };
    }
    if(state && state.id){
      params = {
        id:state.id
      }
    }
    if (params) {
      return Http.get(Request.getEventDetail(), params, obj => {
        console.log('obj', obj);
        if (obj.code == 200) {
          let stepdata = [];
          if (obj.data.itemInformationVO &&
            obj.data.itemInformationVO.itemHandlingProcessVOList &&
            obj.data.itemInformationVO.itemHandlingProcessVOList.length > 0) {
            obj.data.itemInformationVO.itemHandlingProcessVOList.map(function (r, i) {
              stepdata.push({
                name: r.linkName
              })
            })
          }
          this.setState({
            detail: obj.data,
            stepdata: stepdata
          })
        }
      });
    }
  }

  GetUrlParam(paraName) {
    // var url = 'http://yhbest.imwork.net:36012/?id=1435142268298588162';//测试用的假url
    var url = document.location.toString();//获取当前地址栏url
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
      var arrPara = arrObj[1].split("&");
      var arr;

      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");

        if (arr != null && arr[0] == paraName) {
          return arr[1];
        }
      }
      return "";
    }
    else {
      return "";
    }
  }


  handColspan = id => {
    if (id == 1) {
      this.setState({
        colspaned: false
      })
    } else {
      this.setState({
        colspaned: true
      })
    }
  }
  //立即办理点击事件
  okClick = (itemOnlineUrl)=>{
    // console.log(1111)
    if(itemOnlineUrl){
      window.open(itemOnlineUrl)
    }else{
      if(!this.state.flag){
        this.state.flag = true
        Message.error('当前暂不支持在线办理')
        setTimeout(()=>{
          this.state.flag = false  
        },3000)
      }
        }
  }
  banli = () =>{
    console.log(11111)
  }
  render() {
    const { colspaned, stepdata, detail } = this.state;
    return (
      <div className="applaction">
        <Navigation />
        <div style={{ fontSize: 24, fontWeight: 'bold' }}>{detail.itemName}</div>
        <text style={{ display: 'block', marginTop: '6px' }}>{detail.itemInformationVO && detail.itemInformationVO.implementMainstay || ''}</text>
        <div className="button">
          <Button style={{verticalAlign:'middle',height:'38px' }} onClick={()=>{
            this.okClick(detail.itemOnlineUrl)}
            } className={detail.itemOnlineUrl ? 'rightnow' : ''}> 立即办理</Button>
          {/* <Button style={{color: '#E5E5E5'}}  className="reservation" icon={icon2}><img src={icon2} alt=""></img>在线预约</Button>
          <Button style={{color: '#E5E5E5'}} className="advisory" icon={icon3}><img src={icon3} alt=""></img>在线咨询</Button>
          <Button style={{color: '#E5E5E5'}} className="subscription" icon={icon4}><img src={icon4} alt=""></img>指南订阅</Button> */}
        </div>
        <div className="header">基本信息</div>
        <div style={{ width: '100%' }}>
          <div style={{ width: '100%' }}>
            <table className="table table-bordered table-info" style={{ minWidth: '450px' }} data-toggle="table-collapse" data-row="4">
              <tbody>
                <tr style={{ display: 'table-row' }}>
                  <th>事项名称</th>
                  <td colspan="3"><p className="tdcontent">{detail.itemName}</p></td>
                </tr>
                <tr style={{ display: 'table-row' }}>
                  <th>基本编码</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.baseCode || ''}</p></td>
                  <th>实施编码</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.implementCode || ''}</p></td>
                </tr>
                <tr style={{ display: 'table-row' }}>
                  <th>实施主体</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.implementMainstay || ''}</p></td>
                  <th>实施主体编码</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.implementMainstayCode || ''}</p></td>
                </tr>
                <tr style={{ display: 'table-row' }}>
                  <th>实施主体性质</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.implementMainstayNature || ''}</p></td>
                  <th>联办机构</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.jointOrganization || ''}</p></td>
                </tr>
                <tr style={{ display: 'table-row' }}>
                  <th>事项类型</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.itemType || ''}</p></td>
                  <th>办件类型</th>
                  <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.workType || ''}</p></td>
                </tr>
                {!colspaned && <>
                  <tr style={{ display: 'table-row' }}>
                    <th>服务对象</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.serviceObject || ''}</p></td>
                    <th>办理形式</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.processingType || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>是否网办</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.networkOfficenStatus ? detail.itemInformationVO.networkOfficenStatus == 1 ? '是' : '否' : '否'}</p></td>
                    <th>是否收费</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.chargeStatus ? detail.itemInformationVO.chargeStatus == 1 ? '是' : '否' : '否'}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>是否支持网上支付</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.onlinePaymentStatus ? detail.itemInformationVO.onlinePaymentStatus == 1 ? '是' : '否' : '否'}</p></td>
                    <th>是否支持物流快递</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.logisticsExpressStatus ? detail.itemInformationVO.logisticsExpressStatus == 1 ? '是' : '否' : '否'}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>是否支持预约办理</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.bookingStatus ? detail.itemInformationVO.bookingStatus == 1 ? '是' : '否' : '否'}</p></td>
                    <th>是否支持自助终端办理</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.terminalStatus ? detail.itemInformationVO.terminalStatus == 1 ? '是' : '否' : '否'}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>是否进驻政务大厅</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.governmentHallStatus ? detail.itemInformationVO.governmentHallStatus == 1 ? '是' : '否' : '否'}</p></td>
                    <th>中介服务</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.intermediaryServicesStatus ? detail.itemInformationVO.intermediaryServicesStatus == 1 ? '是' : '否' : '否'}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>事项状态</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.itemStatus ? detail.itemInformationVO.itemStatus == 1 ? '启用' : '禁用' : '启用'}</p></td>
                    <th>事项版本</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.itemEdition || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>数量限制</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.numberLimit || ''}</p></td>
                    <th>通办范围</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.tongbanRange || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>移动端是否对接单点登录</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.appSingleSignonStatus ? detail.itemInformationVO.appSingleSignonStatus == 1 ? '是' : '否' : '否'}</p></td>
                    <th>移动端办理地址</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.appAddress || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>计算机端是否对接单点登录</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.pcSingleSignonStatus ? detail.itemInformationVO.pcSingleSignonStatus == 1 ? '是' : '否' : '否'}</p></td>
                    <th>计算机端在线办理跳转地址</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.pcAddress || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>权力来源</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.powerSource || ''}</p></td>
                    <th>审批结果类型</th>
                    <td><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.approvalResultType || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>审批结果名称</th>
                    <td colspan="3"><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.approvalResultName || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>审批结果样本</th>
                    <td colspan="3"><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.approvalResultSample || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>网上办理深度</th>
                    <td colspan="3"><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.networkOfficenDepth || ''}</p></td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <th>行使层级</th>
                    <td colspan="3"><p className="tdcontent">{detail.itemInformationVO && detail.itemInformationVO.exerciseHierarchy || ''}</p></td>
                  </tr></>}
              </tbody>
            </table>
            {colspaned ?
              <a className="table-colspan" onClick={() => this.handColspan(1)}>显示更多<i style={{ marginLeft: '8px' }} className="el-icon-arrow-down"></i></a> :
              <a className="table-colspan" onClick={() => this.handColspan(2)}>收起内容<i style={{ marginLeft: '8px' }} className="el-icon-arrow-up"></i></a>}
          </div>
          <div className="table--top-shadow"></div>
          <div className="table--left-shadow"></div>
          <div className="table--right-shadow"></div>
        </div>
        <div style={{ marginTop: '35px' }} className="header">
          <div>受理条件</div>
          <div className="pcontent">{detail.itemInformationVO && detail.itemInformationVO.acceptanceConditions || ''}</div>
        </div>
        <div className="header">
          设定依据
          <div className="pcontent">{detail.itemInformationVO && detail.itemInformationVO.settingBasis || ''}</div>
        </div>
        <div className="header">
          收费标准和依据
          <div className="pcontent">{detail.itemInformationVO && detail.itemInformationVO.chargingStandardBasis || ''}</div>
        </div>
        <div className="header">
          办理流程
          <div className="process">
            {stepdata && stepdata.length > 0 && stepdata.map((r, i) => {
              return (
                <div className="step">{r.name}</div>
              )
            })}
          </div>
          <Table
            style={{ width: '100%', fontWeight: 400 }}
            columns={this.state.columns}
            data={detail.itemInformationVO && detail.itemInformationVO.itemHandlingProcessVOList || []}
            border={true}
          />
        </div>
        <div className="header">
          申请材料
          <Table
            style={{ width: '100%', fontWeight: 400 }}
            columns={this.state.clcolumns}
            data={detail.itemInformationVO && detail.itemInformationVO.itemApplyMaterialsVOList || []}
            border={true}
          />
        </div>
        <div className="header">
          办理地点
          <div className="pcontent">办理地点：{detail.itemInformationVO && detail.itemInformationVO.processingAddress || ''}</div>
          <div className="pcontent">办理时间：{detail.itemInformationVO && detail.itemInformationVO.processingTime || ''}</div>
          {/* <div className="pcontent">公交路线：{detail.itemInformationVO && detail.itemInformationVO.busRoutes || '无'}</div> */}
        </div>
        <div className="header">
          常见问题
          <div className="pcontent">{detail.itemInformationVO && detail.itemInformationVO.commonProblem || '暂无'}</div>
        </div>
      </div>
    );
  }
}
